module.exports = __webpack_public_path__ + "static/img/3.9f95e22.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/4/zh/3.png
// module id = z37z
// module chunks = 0